module.exports = __webpack_public_path__ + "media/images/abagail_background-962d1b5e8a46a31c2b04a5d0d44d720c.png";